import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Api } from '@carrier/utils/Api';

// Thunk to fetch carriers
export const fetchCarriers = createAsyncThunk(
  'carriers/fetchCarriers',
  async (params, { getState, rejectWithValue }) => {
    try {
      const { page = 1, search = '', forceRefresh = false } = params || {};

      const cacheKey = search ? `${page}_${search}` : `${page}`;

      const { carriersCache } = getState().carriers;

      if (carriersCache[cacheKey] && !forceRefresh) {
        return carriersCache[cacheKey];
      }

      const apiParams = { page };

      if (search) apiParams.name = search;

      const { data, headers } = await Api.loadCarriers(apiParams);
      const pagination = JSON.parse(headers['x-pagination']);

      return {
        data,
        pagination,
        cacheKey,
        currentPage: page,
        searchQuery: search
      };
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch carriers');
    }
  }
);

const initialState = {
  carriersCache: {},
  carriers: [],
  pagination: null,
  loading: false,
  error: null,
  currentPage: 1,
  searchQuery: ''
};

const carriersSlice = createSlice({
  name: 'carriers',
  initialState,
  reducers: {
    clearCache: state => {
      state.carriersCache = {};
    },
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchCarriers.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCarriers.fulfilled, (state, action) => {
        const { data, pagination, cacheKey } = action.payload;

        // Update cache
        state.carriersCache[cacheKey] = { data, pagination };

        // Update current state
        state.carriers = data;
        state.pagination = pagination;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchCarriers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch carriers';
      });
  }
});

export const { clearCache, setSearchQuery, setCurrentPage } = carriersSlice.actions;
export default carriersSlice.reducer;
